module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Bold-13f1b7232cb781366619b02841eb9ded.svg";